
define(
	'TavanoTeam.CapSciExtensions.CSSearchSpringExt'
,   [
		'Facets.Browse.View'
	,	'Profile.Model'
	,	'Footer.View'

	,	'tavanoteam_capsciextensions_cssearchspringext_facets_browse.tpl'

	,	'underscore'
	,	'jQuery'
	,	'Utils'
	]
,   function (
		FacetsBrowseView
	,	ProfileModel
	,	FooterView

	,	tavanoteam_capsciextensions_cssearchspringext_facets_browse_tpl

	,	_
	,	jQuery
	,	Utils
	)
{
	'use strict';

	return  {
		loadSearchSpring: function loadSearchSpring (container)
		{
			_.extend(FacetsBrowseView.prototype, {
				template: tavanoteam_capsciextensions_cssearchspringext_facets_browse_tpl
			,	events: _.extend({}, FacetsBrowseView.prototype.events, {
					'click [class="global-views-pagination-links"] a': "_gotoPage"
				,	'click [class="ss-clear-search"]': "_setEvent"
				,	'click [class="ss-summary-reset"]': "_setEvent"
				,	'click [class="ss-summary-container"] a': "_setEvent"
				})
			,	childViews: _.extend({}, FacetsBrowseView.prototype.childViews, {
					'Facets.ItemListDisplaySelector': {
					},
					'Facets.ItemListSortSelector': {
					},
					// Show 'XX products per page' View
					'Facets.ItemListShowSelector': {
					},
					'GlobalViews.Pagination': {
					}
				})
			,	_setEvent: function _setEvent(e)
				{
					console.log("here")
					e.stopPropagation();
					e.preventDefault();
				}
			,	_gotoPage: function gotoPage(e) 
				{
					this._setEvent(e);
				}
			,	setEvent: function setEvent(event_name, value) 
				{
					console.log("here")
				}
			,	getContext: _.wrap(FacetsBrowseView.prototype.getContext, function(fn)
				{
					var origCtx = fn.apply(this, _.toArray(arguments).slice(1))
					,	profileModel = ProfileModel.getInstance()
					,	breadcrumbs = this.getBreadcrumbPages()
					,	searchSpringCrumbs = [];

					_.each(breadcrumbs, function(crumbs)
					{
						console.log("crumbs.text", crumbs.text);
						searchSpringCrumbs.push(crumbs.text);
					});

					origCtx['level1'] = profileModel.get('isLoggedIn') == 'T' ? true : false;
					origCtx['breadcrumb'] = searchSpringCrumbs.join('>');

					return origCtx;
				})
			});
		}
	};
});
